import styled from 'styled-components';

export const PageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background: var(--black-color);
  padding: 0;
`;

export const HeroSection = styled.section`
  width: 100%;
  padding: 80px 20px 40px;
  text-align: center;
  max-width: 900px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 60px 16px 30px;
  }
`;

export const HeroTitle = styled.h1`
  font-size: 2.4rem;
  font-weight: 800;
  color: var(--white-color);
  margin: 0 0 16px 0;
  line-height: 1.2;
  text-wrap: balance;

  @media (max-width: 768px) {
    font-size: 1.7rem;
  }
`;

export const HeroSubtitle = styled.p`
  font-size: 1.15rem;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const PlansGrid = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 24px;
  max-width: 1200px;
  margin: 40px auto 60px;
  padding: 0 20px;
  flex-wrap: wrap;

  @media (min-width: 1000px) {
    flex-wrap: nowrap;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
    margin: 20px auto 40px;
  }
`;

export const PlanCard = styled.div`
  background: ${props => props.popular
    ? 'linear-gradient(145deg, rgba(255, 153, 0, 0.08), rgba(255, 153, 0, 0.02))'
    : 'linear-gradient(145deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.01))'};
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1.5px solid ${props => props.popular ? 'rgba(255, 153, 0, 0.6)' : 'rgba(255, 255, 255, 0.1)'};
  border-radius: 20px;
  padding: 36px 28px;
  width: 100%;
  max-width: 360px;
  min-height: 540px;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: ${props => props.popular
    ? '0 10px 40px rgba(255, 153, 0, 0.2)'
    : '0 10px 30px rgba(0, 0, 0, 0.3)'};

  &:hover {
    transform: translateY(-6px);
    box-shadow: ${props => props.popular
      ? '0 20px 50px rgba(255, 153, 0, 0.3)'
      : '0 20px 40px rgba(0, 0, 0, 0.4)'};
  }

  @media (max-width: 768px) {
    padding: 28px 22px;
    min-height: auto;
  }
`;

export const PopularBadge = styled.div`
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--primary-color);
  color: white;
  padding: 6px 18px;
  border-radius: 20px;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 1px;
  box-shadow: 0 4px 15px rgba(255, 153, 0, 0.4);
`;

export const PlanTitle = styled.h2`
  font-size: 1.6rem;
  font-weight: 800;
  color: var(--white-color);
  margin: 0 0 6px 0;
  line-height: 1.2;
`;

export const PlanSubtitle = styled.p`
  font-size: 0.92rem;
  color: rgba(255, 255, 255, 0.55);
  margin: 0 0 20px 0;
`;

export const DiscountBadge = styled.div`
  display: inline-block;
  background: linear-gradient(45deg, #4CAF50, #66bb6a);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.78rem;
  font-weight: 700;
  margin: 0 0 12px 0;
  align-self: flex-start;
  box-shadow: 0 2px 10px rgba(76, 175, 80, 0.3);
`;

export const PriceWrapper = styled.div`
  margin: 0 0 24px 0;
`;

export const OriginalPrice = styled.div`
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.4);
  text-decoration: line-through;
  margin-bottom: 4px;
`;

export const Price = styled.div`
  font-size: 2.6rem;
  font-weight: 900;
  color: var(--primary-color);
  line-height: 1;
  display: flex;
  align-items: baseline;
  gap: 6px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

export const PriceUnit = styled.span`
  font-size: 1rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
`;

export const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 30px 0;
  flex: 1;

  li {
    position: relative;
    padding: 10px 0 10px 28px;
    font-size: 0.95rem;
    color: rgba(255, 255, 255, 0.75);
    line-height: 1.4;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);

    &:last-child {
      border-bottom: none;
    }

    &::before {
      content: "✓";
      position: absolute;
      left: 0;
      top: 10px;
      color: var(--primary-color);
      font-weight: 800;
      font-size: 1.05rem;
    }
  }
`;

export const PlanCTA = styled.div`
  margin-top: auto;

  button {
    width: 100%;
    padding: 14px 20px;
    font-size: 1rem;
    font-weight: 700;
    border-radius: 30px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    }
  }
`;

export const ComparisonNote = styled.p`
  text-align: center;
  color: rgba(255, 255, 255, 0.55);
  font-size: 0.9rem;
  max-width: 700px;
  margin: 0 auto 50px;
  padding: 0 20px;
  line-height: 1.6;
`;

export const FooterCTA = styled.section`
  text-align: center;
  padding: 0 20px 80px;
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const FooterCTAText = styled.p`
  font-size: 1.05rem;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
`;
